import React from 'react';
import BankOffers from 'src/components/CouponsAndVouchers/BankOffers';

const BankOffersSection = (props) => {
  return <BankOffers {...props} isCartPage={true} />;
};

export default BankOffersSection;
